
  import React from "react"
  import Component from "/Users/meafmira/projects/meafmira/src/layouts/index.js"
  import data from "/Users/meafmira/projects/meafmira/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js